import { render, staticRenderFns } from "./shareAppMessage.vue?vue&type=template&id=4beef99c&scoped=true&"
import script from "./shareAppMessage.vue?vue&type=script&lang=ts&"
export * from "./shareAppMessage.vue?vue&type=script&lang=ts&"
import style0 from "./shareAppMessage.vue?vue&type=style&index=0&id=4beef99c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beef99c",
  null
  
)

export default component.exports